<template>
  <a class="button" :href="href" target="_blank"
    ><span>{{ label }}</span
    ><img alt="箭头图标" src="../../assets/right-arrow.svg"
  /></a>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "查看详情"
    },
    href: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  background-color: #4392f5;
  padding: 2px 13px;
  text-decoration: none;
  border-radius: 12px;
  line-height: 1;
  color: white;
  float: right;

  & > span {
    vertical-align: middle;
  }

  & > img {
    vertical-align: middle;
    height: 20px;
    width: 20px;
  }

  &:visited {
    color: white;
  }
}
</style>
